import React, { useState, createContext } from 'react';
import SearchFiltersDialog from '../components/modals/SearchFiltersDialog';
import { AccordionType } from '../components/modals/SearchFiltersDialog/SearchFiltersDialog';

type ShowFunc = (scrollTo?: AccordionType, filtersOrder?: AccordionType[], type?: 'core' | 'course') => void;
const noop = () => undefined;

interface Context {
  isOpen: boolean;
  openSearchFiltersDialog: ShowFunc;
}

const defaultContext: Context = {
  isOpen: false,
  openSearchFiltersDialog: noop as ShowFunc,
};

const SearchFiltersDialogContext = createContext(defaultContext);

const SearchFiltersDialogProvider: React.FC = (props) => {
  const [state, setState] = useState<{
    isOpen: boolean;
    scrollTo?: AccordionType;
    filtersOrder: AccordionType[]
    type: 'core' | 'course'
  }>({
    isOpen: false,
    scrollTo: undefined,
    filtersOrder: [],
    type: 'core'
  });

  return (
    <SearchFiltersDialogContext.Provider value={{
      openSearchFiltersDialog: (scrollTo, filtersOrder, type) => {
        setState({ isOpen: true, scrollTo, filtersOrder: filtersOrder || [], type: type || 'core' });
      },
      isOpen: state.isOpen,
    }}>
      <SearchFiltersDialog
        isOpen={state.isOpen}
        handleClose={() => 
          setState({ isOpen: false, scrollTo: undefined, filtersOrder: state.filtersOrder, type: state.type })
        }
        scrollTo={state.scrollTo}
        filtersOrder={state.filtersOrder}
        type={state.type}
      />
      {props.children}
    </SearchFiltersDialogContext.Provider>
  );
};

export { SearchFiltersDialogContext, SearchFiltersDialogProvider };
